export const beneficiaryCreateEventPayload = (data, selectedAccount) => ({
  name: data.name,
  account_id: selectedAccount.id,
  sort_code: data.sort_code,
  account_number: data.account_number,
  display_name: data.display_name,
  reference: data.reference,
  single_use: data.single_use,
  dataContext: 'beneficiary_create',
});
export const beneficiaryUpdateEventPayload = (
  data,
  { account, to_account, sortCode }
) => ({
  name: data.name,
  account_id: account.id,
  old_sort_code: to_account.sort_code,
  new_sort_code: sortCode,
  old_account_number: to_account.account_number,
  new_account_number: data.account_number,
  display_name: data.display_name.trim(),
  reference: data.reference.trim(),
  single_use: 'false',
  dataContext: 'beneficiary_update',
});
